import { forwardRef } from 'react'
import { Home } from '@material-ui/icons'
import { ListItem, ListItemIcon } from '@material-ui/core'
import { StyledListItemText } from '../StyledList'
import { Link as RouterLink } from 'react-router-dom'
import { func } from 'prop-types'

export const HomeButton = ({ onClose }) => (
  <ListItem
    button
    onClick={onClose}
    component={forwardRef((itemProps, ref) => (
      <RouterLink
        underline="none"
        exact="true"
        to="/"
        ref={ref}
        {...itemProps}
      />
    ))}
  >
    <ListItemIcon>
      <Home />
    </ListItemIcon>
    <StyledListItemText primary="Home" />
  </ListItem>
)

HomeButton.propTypes = {
  onClose: func.isRequired,
}
